import { CoreModule, LicenseManager } from "dynamsoft-capture-vision-bundle";

// Configures the paths where the .wasm files and other necessary resources for modules are located.
CoreModule.engineResourcePaths.rootDirectory = "https://cdn.jsdelivr.net/npm/";
const DYNAMSOFT_API_KEY = import.meta.env.VITE_DYNAMSOFT_API_KEY as string;

LicenseManager.initLicense(DYNAMSOFT_API_KEY, { executeNow: true,});

// Optional. Preload "BarcodeReader" module for reading barcodes. It will save time on the initial decoding by skipping the module loading.
CoreModule.loadWasm();